import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import SeoVirtualServices from "services/SeoVirtualServices";
import { notifyError, notifySuccess } from "utils/toast";

const useSeoVirtualSubmit = (id) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);

  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [content, setContent] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    clearErrors,
    formState: { errors },
  } = useForm();

  const getSeoVirtualData = async () => {
    try {
      const res = await SeoVirtualServices.getSeoVirtualById(id);

      if (res?.data) {
        setValue("url",res.data.url);
        setValue("description", res.data.description);
        setValue("keywords", res.data.keywords);
        setValue("title",res.data.title);
        setValue("content", res.data.content);  
        setContent(res.data.content);    
      }
    } catch (err) {
      notifyError("Failed to load data");
    }
  };

  const sanitizeContent = (html) => {
    return html.replace(/<p>\s*<br>\s*<\/p>/g, "").trim();
  };

  const validateContent = () => {
    const cleaned = sanitizeContent(content);
    if (!cleaned) {
      notifyError("Content is required");
      return false;
    }
    return true;
  };

  const onSubmit = async (data) => {
    setLoading(true);
    data.content = content;

    // Validate content
    if (!validateContent()) {
      setLoading(false);
      return;
    }

    try {
      setIsSubmitting(true);

      if (id) {
        const res = await SeoVirtualServices.updateSeoVirtual(id, data);
        setIsUpdate(true);
        notifySuccess("Updated successfully");
        setIsSubmitting(false);
        closeDrawer();
      } else {
        const res = await SeoVirtualServices.addSeoVirtual(data);
        setIsUpdate(true);
        notifySuccess("Added successfully");
        setIsSubmitting(false);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err?.response?.data?.message || err?.message);
      setIsSubmitting(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setValue("url");
      setValue("description");
      setValue("keywords");
      setValue("title");
      setValue("content");
      setContent("");
      clearErrors();
      return;
    }
    if (id) {
      getSeoVirtualData();
    }
  }, [isDrawerOpen, id,clearErrors, setValue]);

  return {
    register,
    handleSubmit,
    onSubmit,
    trigger,
    errors,
    content,
    setContent,
    loading,
    isSubmitting,
  };
};

export default useSeoVirtualSubmit;
